import { OfficialResourceAPI } from '@/server/AssetManage';
import { AssetItem } from '@/type';
import { useQuery } from '@tanstack/react-query';

export const useGetOfficialResources = (categoryId?: number) => {
  const query = useQuery({
    queryKey: ['officialResources', categoryId],
    queryFn: async () => {
      const data = await OfficialResourceAPI.getOfficialResources(
        categoryId ? [categoryId] : undefined,
      );

      const items: AssetItem[] = data.map((d) => {
        return {
          type: d.type,
          name: d.name,
          url: 'url' in d.content ? (d.content.url as string) : undefined,
          id: d.id.toString(),
          thumb: d.thumb || '',
          parentId: d.categoryId.toString(),
          content: d.content as any,
          createdAt: d.createdAt,
          children: [],
        };
      });

      return items;
    },
    staleTime: 0,
  });

  return query;
};
